<div *ngIf="!readonly && internalItems?.length > 0">
  <button (click)="lgModal.show()" [class.btn-img]="imageOnly" class="btn btn-light" id="pickdata{{context}}"
          title="{{ 'COMMON_UI.DATEN_UEBERNAHME.PICKDATA' | translate }}" type="button">
    <em class="icon icon-stammdaten"></em>
    <span *ngIf="!imageOnly">{{ 'COMMON_UI.DATEN_UEBERNAHME.PICKDATA' | translate }}</span>
  </button>

  <div #lgModal="bs-modal" bsModal class="modal fade" id="pickdataDialog{{context}}" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title pull-left">{{ 'COMMON_UI.DATEN_UEBERNAHME.TITEL' | translate }}</h3>
          <button (click)="lgModal.hide()" class="close pull-right" id="cancelpickdata{{context}}" type="button">
          </button>
        </div>
        <div class="modal-body">
          <div class="card dna-card-info">
            <div class="list-group dna-list-group-links">
              <a (click)="pickItem(item)" (keypress)="pickItem(item)" *ngFor="let item of internalItems; let i=index" class="list-group-item"
                 id="item{{context}}{{i}}" [tabindex]="0">
                <ng-container *ngTemplateOutlet="itemTemplate;context:{item: item}"></ng-container>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
